import type { Environment } from '@sg/common';
import { oidcUriNormalizer } from '../utils';
import type { SgApplicationConfiguration } from './types';

const PATHNAME_DETECT_REGEXP = new RegExp(`^(?:#/|#|/)(sg-analyzer)(?:/|\\?|().*)?$`);
const HOSTNAME_DETECT_REGEXP = new RegExp(`^analyzer(?:-.*)?\\.sharegain\\.com$`);
const ALLOWED_HOSTNAMES = [
  'analyser.sharegain.com',
  'odelia.sharegain.com',
];

export const sgAnalyzer: SgApplicationConfiguration = {
  name: 'sg-analyzer',
  matcher: (location: Location) => {
    return PATHNAME_DETECT_REGEXP.test(location.pathname)
      || PATHNAME_DETECT_REGEXP.test(location.hash)
      || HOSTNAME_DETECT_REGEXP.test(location.hostname)
      || ALLOWED_HOSTNAMES.includes(location.hostname);
  },
  authType: 'oidc',
  branding: {
    css: 'sg-analyzer-theme',
    hideSideNav: true,
  },
  beforeLogin(env: Environment) {
    const { oidc } = env;
    oidc.acr_values = 'tenant:Lead,Lender';

    const match = PATHNAME_DETECT_REGEXP.exec(location.pathname) || PATHNAME_DETECT_REGEXP.exec(location.hash);

    // by default, OIDC redirects are set under the assumption of a path app (hostname.com/SG-APPNAME)
    // when it's not the case we need to set the redirects properly.
    if (!match) {
      oidcUriNormalizer(oidc);
    }

    const isOdelia = location.hostname === 'odelia.sharegain.com';
    if (isOdelia) {
      this.name = 'sg-odelia';
      oidc.acr_values = 'tenant:LeadOTF';
    }
  },
}
